import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=43b6eaad&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=43b6eaad&prod&lang=scss&scoped=true"
import style1 from "./LanguageSwitcher.vue?vue&type=style&index=1&id=43b6eaad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b6eaad",
  null
  
)

export default component.exports